// src/context/context-utils.ts
var validValue = (value) => value !== void 0 && value !== null && value !== "";
var pickByValidValues = (obj) => pickBy(obj, validValue);
function pickBy(object, predicate = (value) => !!value) {
  if (!object) {
    return {};
  }
  const result = {};
  for (const key in object) {
    if (predicate(object[key], key)) {
      result[key] = object[key];
    }
  }
  return result;
}
var generateTagsAndContext = (context) => {
  const tags = pickByValidValues({
    "app.id": context.appId,
    "app.version": context.appVersion,
    "app.instanceId": context.appInstanceId,
    "extension.id": context.extensionId,
    "extension.name": context.extensionName,
    "extension.type": context.extensionType,
    platform: context.platform
  });
  const contexts = pickBy(
    {
      "extension.data": pickByValidValues({
        ...context.extensionData
      }),
      site: pickByValidValues({
        url: context.siteUrl,
        id: context.tenantType === "SITE" ? context.tenantId : void 0
      }),
      account: pickByValidValues({
        id: context.tenantType === "ACCOUNT" ? context.tenantId : void 0
      })
    },
    (value) => !!value && Object.keys(value).length > 0
  );
  return {
    tags,
    contexts
  };
};

// src/fallback-client.ts
var FallbackMonitoringClient = class {
  constructor(message) {
    this.message = message;
    this.captureException = () => {
      console.error(this.message);
    };
    this.captureMessage = () => {
      console.error(this.message);
    };
    this.startSpan = (spanOptions, callback) => {
      console.error(this.message);
      return callback(void 0);
    };
    this.startSpanManual = () => {
      console.error(this.message);
      return {
        end: () => {
        },
        fail: () => {
        }
      };
    };
    this.endSpanManual = () => {
      console.error(this.message);
    };
    this.addBreadcrumb = () => {
      console.error(this.message);
    };
  }
};
var createFallbackMonitoringClient = (message) => {
  return new FallbackMonitoringClient(message);
};
export {
  createFallbackMonitoringClient,
  generateTagsAndContext
};
